/**
 * Where a preview reads bytes from: a URL, or a function resolving to one — for
 * consumers that cannot hand one over up front, e.g. bytes streamed through an API
 * into an object URL. A function must be a stable reference: a preview watching its
 * source reloads whenever it changes.
 */
export type PreviewSource = string | (() => Promise<string>);

/** An object URL a resolver minted is the preview's to release; a plain URL is not. */
export async function resolvePreviewSource(
  source: PreviewSource
): Promise<{ url: string; isOwned: boolean }> {
  const url = typeof source === 'function' ? await source() : source;

  return { url, isOwned: typeof source === 'function' && url.startsWith('blob:') };
}
